<!-- Universal Wait Spinner -->

<template>
	<div class="wait-shadow" v-if="wShow">
			
		<div class="spinner-outer">
			<div class="spinner-inner" />
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState('api', ['wait']),
	},
	data() {
		return {
			wTimer: 0,
			wDelay: 500,
			wShow: false,

			maxTimer: 0,
			maxDelay: 10000,
		};
	},
	methods: {
		startTimer() {
			m("start timer", this.wait);
			clearTimeout(this.wTimer);
			clearTimeout(this.maxTimer);
			this.wShow = false;
			if (this.wait===true) {
				
				// Delay until show
				this.wTimer = setTimeout(() => {
					this.wShow = true;
				}, this.wDelay);
				
				// Maximum display time
				this.maxTimer = setTimeout(() => {
					this.wShow = false;
					this.$store.dispatch('api/toggleWait', 'clear');
				}, this.maxDelay);
			}
		},
	},
	watch: {
		wait: {
			handler: function (newVal, oldVal) {
				this.startTimer();
			}
		},
	},

}
</script>

<style scoped>

.wait-shadow {
	position: absolute;
	z-index: 100;
	width: 100%;
	height: 100%;
	overflow: hidden;
	/* background-color: #999; */
	/* opacity: 0.5; */
	background:rgba(238, 238, 238, .6);
	border-radius: 8px;
	border: solid 0px #F60;
}

.spinner-outer {
	position: relative;
	width: 60px;
	height: 60px;
	top: 40%;
	margin: 0 auto;
	padding: 5px;
	border-radius: 50%;
	background-color: #FFF;
}

.spinner-inner {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	border: solid 10px #369;
	border-top: solid 10px #FFF;
	animation: go_spin 2s linear infinite;
}

@keyframes go_spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
</style>
